<template>
  <div class="ti">
    <div class="ti__desc">
      Items must be in excellent to lightly worn condition, with no major rips,
      holes, tears, missing buttons or snaps, broken zippers, alterations,
      stains, odors, or pet hair. We do not accept: Swimwear, co-branded items,
      accessories (hats, scarves, beanies, socks, bags & packs), t-shirts,
      underwear, baselayers or any products under $50 MSRP.
    </div>
    <div class="ti__sub-desc">
      Still not sure if your items meet the requirements?
      <a href="#trade-in-faq">View our FAQ</a>.
    </div>
  </div>

  <div id="wufoo-z1q3qv3e1pcsyuz" class="wufooContainer">
    <div class="ti__loader"></div>
  </div>
</template>

<script setup>
import { onBeforeMount, onMounted } from "vue";

const emit = defineEmits(["heading", "component-updated"]);

onBeforeMount(() => {
  emit(
    "heading",
    "Trade In"
  );
});

onMounted(() => {
  emit('component-updated');
})

var z1q3qv3e1pcsyuz;
(function (d, t) {
  var s = d.createElement(t),
    options = {
      userName: "stio",
      formHash: "z1q3qv3e1pcsyuz",
      autoResize: true,
      height: "1079",
      async: true,
      host: "wufoo.com",
      header: "show",
      ssl: true,
    };
  s.src =
    ("https:" == d.location.protocol ? "https://" : "http://") +
    "secure.wufoo.com/scripts/embed/form.js";
  s.onload = s.onreadystatechange = function () {
    var rs = this.readyState;
    if (rs) if (rs != "complete") if (rs != "loaded") return;
    try {
      z1q3qv3e1pcsyuz = new WufooForm();
      z1q3qv3e1pcsyuz.initialize(options);
      z1q3qv3e1pcsyuz.display();
    } catch (e) {}
  };
  var scr = d.getElementsByTagName(t)[0],
    par = scr.parentNode;
  par.insertBefore(s, scr);
})(document, "script");
</script>
